module.exports = "<div ng-if=\"item()\">{{ {amount: item().getValue(), currency: item().getPropertyInfo().getCurrency()} | gwCurrency }}</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/readonly-form/templates/currency.html
// module id = 439
// module chunks = 0